import './FamilyFaqSection.scss';

import { FaqAccordion, FaqAccordionItem } from '@components/FaqAccordion/FaqAccordion';
import { MarketingSectionIntro } from '@components/marketing/MarketingSectionIntro/MarketingSectionIntro';

export const FAMILY_FAQ_ITEMS: FaqAccordionItem[] = [
  {
    id: 'report-privacy',
    question: 'Will my relatives see my report or know it was me?',
    answer:
      'No. Your report stays private to you and your care team. Each relative gets a separate invitation — we never share your name or results with them unless you tell them yourself.',
  },
  {
    id: 'acceptance',
    question: 'Will I see whether my relatives accepted?',
    answer:
      "We confirm which invitations were sent. We don't show whether each one opened, accepted, or declined — that's private to them.",
  },
  {
    id: 'missing-email',
    question: "What if I don't have a relative's email?",
    answer: 'Skip them for now and come back when you have it. We only contact relatives we have a working email for.',
  },
];

export const FamilyFaqSection = () => (
  <section className='fvt-family-faq' aria-labelledby='fvt-family-faq-heading'>
    <MarketingSectionIntro
      variant='fvt'
      className='fvt-family-faq__intro'
      heading='Common questions'
      headingId='fvt-family-faq-heading'
    />

    <FaqAccordion
      className='fvt-family-faq__accordion'
      items={FAMILY_FAQ_ITEMS}
      defaultOpenIds={[FAMILY_FAQ_ITEMS[0].id]}
      idPrefix='fvt-family-faq'
    />
  </section>
);
